"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _BorrowerReadOnlyPanel = _interopRequireDefault(require("./BorrowerReadOnlyPanel"));

var _BorrowerVerifyIdentity = _interopRequireDefault(require("./BorrowerVerifyIdentity"));

var _BorrowerChoosePassword = _interopRequireDefault(require("./BorrowerChoosePassword"));

var _styles = require("../../styles");

var _useMobile = require("../../hooks/useMobile");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = function styles(theme) {
  return {
    borrower: {}
  };
};

exports.styles = styles;
var useStyles = (0, _styles.makeStyles)(styles);

var BorrowerFlow = function BorrowerFlow(_ref) {
  var claimToken = _ref.claimToken,
      onSuccess = _ref.onSuccess,
      links = _ref.links,
      client = _ref.client,
      isPartnerBorrower = _ref.isPartnerBorrower;
  var classes = useStyles();
  var isMobile = (0, _useMobile.useIsMobileXsOnly)();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isClaimed = _useState2[0],
      setisClaimed = _useState2[1];

  var onClaim = function onClaim() {
    setisClaimed(true);
  };

  var flowDirection = isMobile ? 'row' : 'row-reverse';
  return /*#__PURE__*/_react["default"].createElement(_.Grid, {
    container: true,
    align: "center",
    className: classes.borrower,
    direction: flowDirection
  }, isClaimed ? /*#__PURE__*/_react["default"].createElement(_BorrowerChoosePassword["default"], {
    claimToken: claimToken,
    onSuccess: onSuccess,
    links: links
  }) : /*#__PURE__*/_react["default"].createElement(_BorrowerVerifyIdentity["default"], {
    claimToken: claimToken,
    onSuccess: onClaim,
    links: links,
    client: client,
    isPartnerBorrower: isPartnerBorrower
  }), /*#__PURE__*/_react["default"].createElement(_BorrowerReadOnlyPanel["default"], {
    isClaimed: isClaimed
  }));
};

BorrowerFlow.propTypes = {
  claimToken: _propTypes["default"].string.isRequired,
  onSuccess: _propTypes["default"].func.isRequired,
  links: _propTypes["default"].object.isRequired,
  client: _propTypes["default"].object.isRequired
};
var _default = BorrowerFlow;
exports["default"] = _default;